import { BlankCell as BlankCellType } from "@/financeModels/owasco/types";
import { PrimitiveAtom } from "jotai";
import { memo } from "react";
import { Wrapper } from "./cell/Wrapper";

export type BlankCellProps = {
  tabX: number;
  tabY: number;
  atom: PrimitiveAtom<BlankCellType>;
  ta?: "left" | "right" | "center";
};

export const BlankCell = memo(() => {
  return <Wrapper>{null}</Wrapper>;
});
